import React from 'react';
import { CaretLeftFill } from 'react-bootstrap-icons';
import CareMapprButton from '../../../components/Button/CareMapprButton';

const MedicationProfileTitle = ({
  btnClassNames,
  actions,
  title,
  titleClassName,
  showBackButton,
  onBack,
}) => {
  return (
    <div className="medication-profile-title">
      {showBackButton ? (
        <div className="d-flex flex-column">
          <CareMapprButton
            extraClassNames="ps-0"
            contentAlign="start"
            variant="link"
            onClick={onBack}
            startIcon={<CaretLeftFill size={9} />}
            label="Back to full list"
            hoverWithColor={false}
          />
          <span className={titleClassName}>{title}</span>
        </div>
      ) : (
        <span className={titleClassName}>{title}</span>
      )}

      <div className="d-flex gap-2">
        {actions &&
          actions.map(({ name, icon, onClickAction, variant }, index) => {
            const buttonVariant = variant || 'btnPrimary';
            return (
              <div
                className="medication-profile-title-actions"
                key={`action-${index}`}
              >
                <button
                  className={`btn ${buttonVariant} ${btnClassNames || ''}`}
                  onClick={onClickAction}
                >
                  {name}
                  {icon}
                </button>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default MedicationProfileTitle;
